import { SET_AUDIT_AREA } from '../../constants/appTypes';

const initialState: {
  graphic: __esri.Graphic | null;
  size: number;
  treeLoss: Array<number>
} = {
  graphic: null,
  size: 0,
  treeLoss: []
};

interface auditAreaAction {
  graphic: __esri.Graphic | null;
  size: number;
  treeLoss: Array<number>;
  type: string;
}

export function auditArea(state = initialState, action: auditAreaAction) {
  switch (action.type) {
    case SET_AUDIT_AREA:
      const { graphic, size, treeLoss } = action;
      state = { graphic, size, treeLoss };
      return state;
    default:
      return state;
  }
}

export default auditArea;
